
<template>
  <div>
    <commonHeader> </commonHeader>

    <mt-tab-container v-model="selected">
      <mt-tab-container-item id="2" style="width: 100%; margin-bottom: 46px">
        <ul>
          <div
            v-for="item in listfourth"
            style="
              text-align: center;
              margin-left: 9px;
              margin-right: 9px;
              margin-bottom: 15px;
              box-shadow: 0 0 0 1px #e0e0e0; /* 模拟1px的灰色边框 */
            "
          >
            <p class="box">
              <span
                style="line-height: 35px; font-size: 16px; padding-left: 10px"
              >
                {{ item.title }}
              </span>
            </p>
            <div style="display: inline-table">
              <img
                v-lazy.container="item.image"
                alt=""
                style="width: 100%; padding: 5px 5px 5px 5px"
                @click="go20(item.link)"
                v-bind:style="{ height: heightSize + 'px' }"
              />
              <div style="display: flex;align-items: center;justify-content: center;">
                <span style="font-weight: normall; margin-right: 5px"
                  >日期:{{ item.time }}
                </span>
                <span style="font-weight: normal; margin-left: 5px">
                  作者:{{ item.author || "" }}
                </span>
              </div>
            </div>
          </div>
        </ul>
      </mt-tab-container-item>
    </mt-tab-container>
  </div>
</template>
 
<script>
import Addr from "./../utils/getAPI";
import openUrl from "./../utils/openUrl";
import commonHeader from "./../components/common-header.vue";
import axios from "axios";

export default {
  name: "party20",
  components: {
    commonHeader,
  },
  data: function () {
    return {
      heightSize: 200,
      startShow: true,
      selected: "2",
      //三个大分类
      listfourth: [],
    };
  },

  mounted() {
    this.initdata();

    setTimeout(() => {
      this.startShow = false;
    }, 2000);
  },
  updated() {},

  methods: {
    initdata() {
      axios
        .get(Addr.getGoNewAPIPrefix() + "fourth/listfourth")
        .then((res) => {
          console.log("fourth", res);
          if (res.status == 200) {
            this.listfourth = res.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadTop() {
      // 加载更多数据
      this.$refs.loadmore.onTopLoaded();
    },
    loadBottom() {
      // 加载更多数据
      this.allLoaded = true; // 若数据已全部获取完毕
      this.$refs.loadmore.onBottomLoaded();
    },
    go20(link) {
      // console.log('linklinklinklink',link)
      openUrl.open(link);
    },
  },
};
</script>
 
<style scoped>
.is-selected {
  color: white;
  text-align: center;
}
.box {
  width: 100%;
  height: 100%;
  /* 设置元素两端对齐 */
  text-align: justify;
  text-align: justify;
  margin-bottom: 0px;
  height: 35px;
  background-color: white;
}
/* 这里的伪元素一定要加上，不然span元素不能两端对齐 */
.box:after {
  content: "";
  display: inline-block;
  overflow: hidden;
  width: 90%;
}
.box span {
  /* 设置盒子为行内块 */
  display: inline-block;
  /* 设置盒子内元素水平居中 */
  text-align: center;
}
.grind {
  display: grid;
  grid-template-columns: 2fr;
  /* grid-template-rows: 100px 100px 100px; */
  grid-template-rows: 280px;
  grid-gap: 10px;
  padding: 20px;
  margin-left: 3%;
  margin-right: 3%;
  text-align: center;
}

.item {
  position: relative;
  border: 1px solid rgba(211, 14, 14, 0.666);
  height: 280px;
}
img {
  /* width: 100%; */
  height: 100%;
}
.wkpop {
  width: 100%;
  height: calc(100% - 55px);

  margin-top: 15px;
  margin-bottom: 5px;
  border: solid 3px pink;
  border-top-left-radius: 15px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>


// WEBPACK FOOTER //
// src/module-fourth/index.vue